import { BlockReferenceArray } from '@/cms/types/block';
import { BlockComponentModel } from '@/cms/types/blok-component';
import { cmsApiEndpoint } from '@/constant/env';
import { RelatedArticlesStrapiProps } from '@/decodo/components/organisms/relatedArticles/RelatedArticlesStrapi';
import { apiCall, withStrapiHeaders } from '@/utils/fetch';
import { MetadataStrapiProps } from './RelatedArticlesStrapi';
/**
 * Helper function for related articles block.
 *
 * If a blog author is assigned, fetch all articles related to that author instead of rendering the ones already assigned to the block.
 */

export async function SSR_getRelatedArticlesForAuthor({
  authorSlug: author,
}: {
  authorSlug: string;
}): Promise<BlockReferenceArray<MetadataStrapiProps> | null> {
  const relatedArticles = await apiCall<
    BlockReferenceArray<MetadataStrapiProps>
  >({
    headers: withStrapiHeaders({}),
    // NOTE: this query is pretty slow and should only be used for static pages, hense the SSR_ prefix.
    // Stringing multiple populate queries together is not properly documented in Strapi, so having to go around it;
    // commented out as a temp reminder that this hell exists.
    // url: `${cmsApiEndpoint}/blogs?filters[metadata][author][name][$eq]=${author}&pagination[pageSize]=100&populate[metadata][populate][image][populate]=*&populate[metadata][populate]=author`,
    url: `${cmsApiEndpoint}/blogs?filters[metadata][author][authorPageSlug][$containsi]=${author}&pagination[pageSize]=100&pLevel=1`,
  });

  // in case its not a valid author
  if (relatedArticles?.error) {
    return null;
  }

  if (relatedArticles?.data) {
    return relatedArticles.data;
  }

  return null;
}
export async function SSR_getRelatedArticlesToRender(
  block: BlockComponentModel<RelatedArticlesStrapiProps>['block']
) {
  const authorSlug =
    block?.blog_author?.blogAuthor?.data?.attributes?.authorPageSlug || '';

  if (!authorSlug) {
    // if no author is assigned, return the articles already assigned to the block
    return block.articles as BlockReferenceArray<MetadataStrapiProps>;
  }

  const authorArticles = await SSR_getRelatedArticlesForAuthor({
    authorSlug: authorSlug,
  });

  if (!authorArticles?.data) {
    return block.articles;
  }

  return authorArticles as unknown as BlockComponentModel<RelatedArticlesStrapiProps>['block']['articles'];
}

export function authorSlugToUrl(authorSlug: string): string {
  return authorSlug.startsWith('/') ? authorSlug : `/${authorSlug}`;
}
